import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyPlan } from '@/features/my-plan'

export const Route = createFileRoute('/_authenticated/_organization/my-plan/')({
  beforeLoad: async () => requireRoles(['client', 'primary_contact', 'supported_employee']),
  component: MyPlan,
})
